// Main Login component for Smart Pay POS
import React, { useEffect, useState, useContext } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { EventsFetchAPI } from '../../api/Events';

// User context for global user state
import UserContext from "../../context/UserContext";

// API imports for business logic
import { UsersFetchAPI } from '../../api/Users';
import { BusinessFetchAPI } from '../../api/Business';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { MachinesFetchAPI } from '../../api/Machines';
import { TablesFetchAPI } from '../../api/Tables';
import { AuthFetchAPI } from '../../api/Auth';
import { getStartupPath } from '../utils/resolveStartupRoute';
import Keyboard from '../utils/Keyboard';
// SweetAlert2 for alerts
import Swal from "sweetalert2";
// Logo image
import logo_sp from '../img/logos/icon-black.png';
// Utility for conditional rendering
import { RenderIf } from '../utils/RenderIf'
// Estilos del rediseño (solo visual)
import './login.css';

// Helper SOLO visual para iniciales de avatar (no es lógica de negocio)
const splInitials = (name = '') =>
    name.trim().split(/\s+/).map(w => w[0] || '').slice(0, 2).join('').toUpperCase();

const Login = () => {
    /**
     * Filters and returns only active and current/future events.
     * Adds 'tipoEvento' and 'event_date_id' to each event object.
     */
    const getActiveCurrentEvents = (eventsList) => {
        const today = new Date();
        const result = [];
        eventsList.forEach(event => {
            // Only process events with state=1 and valid dates array
            if (event.state !== 1 || !Array.isArray(event.dates)) return;
            let tipoEvento = null;
            let eventDateId = null;
            event.dates.forEach(dateObj => {
                const initialDate = new Date(dateObj.initialDate);
                const maxDate = new Date(dateObj.maxDate);
                // If event is currently active
                if (today >= initialDate && today <= maxDate) {
                    tipoEvento = 'En curso';
                    eventDateId = dateObj.event_date_id;
                } else if (initialDate > today && !tipoEvento) {
                    // If event is upcoming
                    tipoEvento = 'Próximo';
                    eventDateId = dateObj.event_date_id;
                }
            });
            // Add event to result if it is current or upcoming
            if (tipoEvento) {
                result.push({ ...event, tipoEvento, event_date_id: eventDateId });
            }
        });
        return result;
    };
    // --- State Definitions ---
    // Holds business info
    const [businessData, setBusinessData] = useState({
        name: '',
        id: 0
    });


    const [passwordUser, setPasswordUser] = useState('');
    const [btnReturnEvents, setBtnReturnEvents] = useState(false);
    const [eventListener, setEventListener] = useState(0)
    const [branchoffices, setBranchoffices] = useState([]);
    const [branchInView, setBranchInView] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState();
    const [users, setUsers] = useState([]);
    const [branchofficeTables, setBranchofficeTables] = useState([]);
    const [statusAuth, setStatusAuth] = useState(false);
    const [selectedBranchTable, setBranchTable] = useState();
    const [moduloEvents, setModuloEvents] = useState(false);
    const [branchofficeMachines, setBranchofficeMachines] = useState([]);
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [stepEvent, setStepEvent] = useState(true); // true: selección evento, false: flujo normal
    const [machinesEvent, setMachinesEvent] = useState([]);

    //Context 
    const { setUserData } = useContext(UserContext);
    //Params
    const { business_code, branchoffice_code } = useParams();
    //Navigation
    const navigate = useNavigate();
    //Location page 
    const url_path = useLocation();
    const [tokenTemp, setTokenTemp] = useState("");

    /**
     * Generates a public token for the business and fetches events.
     * Receives business_id explicitly instead of reading it from `businessData`
     * state, because `setBusinessData` hasn't flushed yet when this runs right
     * after it in `getInitialData` — reading the state here used to send
     * business_id: 0 and break the session cookie used by permission_access,
     * branchoffice and event.
     */
    const generateToken = async (business_id) => {
        try {
            const response = await AuthFetchAPI.generatePublicToken({ business_id });
            console.log(response.data.token);
            setTokenTemp(response.data.token);
            getEvents(response.data.token);
            return response.data.token;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    /**
     * Fetches events for the business using the provided token.
     * Filters events to only show active/current/future events.
     */
    const getEvents = async (token) => {
        try {
            const response = await EventsFetchAPI.getEventsByBusiness(false, token);
            let listEvents = response.data.events;
            const activeCurrentEvents = getActiveCurrentEvents(listEvents);
            setEvents(activeCurrentEvents);
        } catch (err) {
            setEvents([]);
        }
    }

    /**
     * Fetches branch offices associated with a selected event.
     * Filters branches to only those linked to the event.
     */
    const getBranchByEvent = async (event) => {
        let eventObj = JSON.parse(event);
        try {
            const response = await EventsFetchAPI.getBranchByEvent(eventObj.id, tokenTemp);
            const filteredBranches = branchoffices.filter(branch1 =>
                response.data.branchoffices.some(branch2 => branch2.branchoffice_id === branch1.branchofficeId)
            );
            // Fetch machines for the event
            getMachinesByEvent(eventObj);
            setBranchInView(filteredBranches);
        } catch (err) {
            // Error handling intentionally left empty
        }
    }

    /**
     * Fetches machines associated with a selected event.
     */
    const getMachinesByEvent = async (event) => {
        try {
            const response = await EventsFetchAPI.getMachinesByEvent(event.event_date_id, tokenTemp);
            setMachinesEvent(response.data.machines);
        } catch (err) {
            console.log(err);
        }
    }


    /**
     * Fetches initial business and branch office data on page load.
     * Handles event module activation and machine/table setup for special routes.
     */
    const getInitialData = async (business_code) => {
        let response_business = '';
        let response_branchoffices = ''
        let publicToken = null;
        try {
            // Fetch business info
            response_business = await BusinessFetchAPI.getBusinessByCode(business_code)
            setBusinessData(response_business.data.business)
            // Enable event module if business has events enabled
            if (response_business.data.business.events_enabled === 1) {
                setModuloEvents(true);
            }
            // Must run before branchoffice/permission_access/event calls below:
            // it's what the public token these endpoints need. We pass it
            // explicitly (not just via cookie) below, since third-party/cross
            // -site cookies get blocked on Android and some Chrome setups even
            // when they show up fine in desktop devtools.
            publicToken = await generateToken(response_business.data.business.id);
        } catch (err) {
            // Redirect to no match page on error
            navigate('/nomatch')
        }
        try {
            // Fetch branch offices for the business
            response_branchoffices = await BranchOfficeFetchAPI.getBranchOfficesByBusiness(response_business.data.business.id, publicToken)
            setBranchoffices(response_branchoffices.data.data)
            setBranchInView(response_branchoffices.data.data)
        } catch (err) {
            setBranchoffices([])
            setBranchInView([])
        }
        // Special route: comanda setup
        if (url_path.pathname.includes('comanda')) {
            try {
                const branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(business_code, branchoffice_code, publicToken)
                let response = await MachinesFetchAPI.getMachinesByBranchOfficeAndType(branch.data.branchoffice.id, 6);
                setBranchofficeMachines(response.data.data);
                setSelectedBranch(branchoffice_code);
            } catch (err) {
                setBranchofficeMachines([]);
                setSelectedBranch(null);
            }
        }
        // Special route: tables and machines setup
        if (url_path.pathname.includes('tables') && url_path.pathname.includes('machines')) {
            try {
                const branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(business_code, branchoffice_code, publicToken)
                let token = localStorage.getItem('x-access-machine-token')
                getBranchofficeTables(branch.data.branchoffice.id, token)
            } catch (err) {
            }
        }
        // Trigger event listener to refresh state
        setEventListener(1)
    }

    /**
     * Signs out the current machine and clears all relevant local storage.
     * Redirects to machine login page.
     */
    const signout = async () => {
        let machine_token = localStorage.getItem('x-access-machine-token');
        let machine = JSON.parse(localStorage.getItem('machine_original'));
        try {
            const response = await MachinesFetchAPI.updateMachineStatus(machine.code, false, machine_token)
            if (response.data.success === true) {
                // Clear all tokens and user/machine info
                localStorage.setItem('x-access-token', "");
                localStorage.setItem('x-access-machine-token', "");
                localStorage.setItem('user', "");
                localStorage.setItem('machine', "");
                localStorage.setItem('branchoffice', "");
                localStorage.setItem('business', "");
                localStorage.setItem('table', "");
                localStorage.removeItem("generalData");
                localStorage.removeItem("codeParthner");
                localStorage.removeItem("external_menu_manual");
                localStorage.removeItem("table");
                localStorage.removeItem("waiters");
                localStorage.clear();
                // Redirect to machine login
                navigate(`/machines/login/${business_code}`);
            }
        } catch (err) {
            localStorage.clear();
            // Error handling intentionally left empty
        }
    }

    /**
     * Fetches users for a branch office or business, depending on login type and role.
     */
    const getUsers = async (branchoffice_id, branch_code) => {
        try {
            let response;

            response = await UsersFetchAPI.getUsersByPermissionAccess(branchoffice_id, 'pos_login', tokenTemp);
            setSelectedBranch(branch_code);
            setUsers(response.data.users);
        } catch (err) {
            setUsers([])
            setSelectedBranch(null)
        }
    }

    /**
     * Handles user login form submission.
     * Validates branch selection and redirects based on user role.
     */
    const submit = async (e) => {
        e.preventDefault();
        // Validate branch selection for login
        if ((url_path.pathname.includes('cashier') && selectedBranch !== null) || (url_path.pathname.includes('dispatcher') && selectedBranch !== null) || (!url_path.pathname.includes('dispatcher') || !url_path.pathname.includes('cashier') && selectedBranch === undefined || selectedBranch === null)) {
            const form = new FormData(e.target);
            let user_logged = Object.fromEntries(form.entries());
            user_logged.business_id = businessData.id;
            try {
                const response = await AuthFetchAPI.login(user_logged);
                let token = response.data.token;
                let user = response.data.user;
                // Store user and token info
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('user_original', JSON.stringify(user));
                localStorage.setItem('x-access-token', token);
                setUserData({ token, user: user });
                // Redirect based on user role
                if (user.role === 4) {
                    navigate(`/cashier/${business_code}/${selectedBranch}`)
                } else if (user.role === 5) {
                    navigate(`/orders_customers/${business_code}/${selectedBranch}`)
                } else if (user.role === 3 || user.role === 6) {
                    navigate(`/transactions/${business_code}`)
                }
            } catch (err) {
                Swal.fire({
                    icon: "error",
                    title: err.response.data.error,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        } else {
            // Show error if no branch selected
            Swal.fire({
                icon: "error",
                title: 'Seleccione una sucursal',
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }

    //Function to get the machines of a branch office 
    const getMachinesBranchoffice = async (branchoffice_id, branch_code) => {
        try {
            let response = []
            if (url_path.pathname.includes('machines') && !url_path.pathname.includes('tables')) {
                //We get the machines by branchoffice and by type (3 in this case is for only pos machines)
                response = await MachinesFetchAPI.getMachinesByBranchOfficeAndType(branchoffice_id, 3, tokenTemp);
            }

            if (url_path.pathname.includes('machines') && url_path.pathname.includes('tables')) {
                //We get the machines by branchoffice and by type (8 in this case is for only smartpay table)
                response = await MachinesFetchAPI.getMachinesByBranchOfficeAndType(branchoffice_id, 8);
            }

            if (url_path.pathname.includes('comanda')) {
                //We get the machines by branchoffice and by type (6 in this case is for only comanda)
                response = await MachinesFetchAPI.getMachinesByBranchOfficeAndType(branchoffice_id, 6, tokenTemp);

            }

            if (moduloEvents == true) {
                const filteredMachines = response.data.data.filter(machines =>
                    machinesEvent.some(MachineEv => MachineEv.machine_per_branchoffice_id === machines.machine_per_branch_id)
                );

                console.log(response.data.data);
                console.log(machinesEvent);
                console.log(filteredMachines);
                setBranchofficeMachines(filteredMachines);
            } else {
                setBranchofficeMachines(response.data.data.filter(element => element.is_archived === 0 || element.is_archived === null || element.is_archived === undefined));
            }



            setSelectedBranch(branch_code);

        } catch (err) {
            //If we get some error we set the machines data empty 
            setBranchofficeMachines([])
            //We check the page
            if (url_path.pathname.includes('machines ')) {
                setSelectedBranch(null)
            }
        }
    }

    //Event valid sesion of the machine
    /**
     * Valida que todos los parámetros requeridos de localStorage existan y sean válidos para una sesión de máquina.
     * Si todo es correcto, redirige a la pantalla de pagos. Si falta algún dato, limpia la sesión.
     */
    // Function to validate the token
    const validToken = async (business, branchoffice_info) => {
        try {
            // Call the API to validate the token
            const response = await AuthFetchAPI.validToken(localStorage.getItem('x-access-token'));
            if (response.data !== true) {
                // If the token is invalid, sign out the user
                signout();
            } else {
                navigate(getStartupPath(business.code, branchoffice_info.code));
            }
        } catch (err) {
            console.log(err);
            if (err?.response?.status === 401) {
                // El servidor dijo que el token caduco: ahi si se cierra sesion y se libera la caja.
                signout();
            } else {
                // Sin red, timeout o error del servidor: no es un token malo. Soltar la caja aqui la dejaba
                // libre para que otro equipo la tomara; se conserva la sesion y el POS la valida al abrir.
                navigate(getStartupPath(business.code, branchoffice_info.code));
            }
        }
    };

    const authValidSesion = () => {
        const token = localStorage.getItem("x-access-machine-token");
        const businessStr = localStorage.getItem("business");
        const branchofficeStr = localStorage.getItem("branchoffice");
        const machineStr = localStorage.getItem("machine");

        // Validar existencia y formato de los datos
        if (
            token && token !== "" &&
            businessStr && businessStr !== "" &&
            branchofficeStr && branchofficeStr !== "" &&
            machineStr && machineStr !== ""
        ) {
            let business, branchoffice_info, machine;
            try {
                business = JSON.parse(businessStr);
                branchoffice_info = JSON.parse(branchofficeStr);
                machine = JSON.parse(machineStr);
            } catch (e) {
                // Si hay error en el parseo, limpiar sesión
                localStorage.setItem('x-access-machine-token', "");
                localStorage.setItem('business', "");
                localStorage.setItem('branchoffice', "");
                localStorage.setItem('machine', "");
                return;
            }
            // Validar que los objetos tengan los campos requeridos
            if (
                business && business.code &&
                branchoffice_info && branchoffice_info.code &&
                machine && machine.code
            ) {
                //navigate(`/payments/${business.code}/${branchoffice_info.code}`);
                validToken(business, branchoffice_info)
                return;
            }
        }
        // Si falta algún dato, limpiar sesión
        localStorage.setItem('x-access-machine-token', "");
        localStorage.setItem('business', "");
        localStorage.setItem('branchoffice', "");
        localStorage.setItem('machine', "");
    }

    // Performs the actual /auth/loginsmartpay call and, on success, all the resulting navigation/
    // localStorage setup. Split out from loginMachine so it can be retried unchanged once the
    // cashier confirms taking over an occupied terminal (force_transfer added to machinePayload).
    const attemptLoginMachine = async (machinePayload) => {
        const response = await AuthFetchAPI.loginSmartPay(machinePayload);
        setStatusAuth(false)
        //We get the token and user data
        let token = response.data.token;
        let business = response.data.business;
        let branchoffice = response.data.branchoffice;
        let machine_info = response.data.machine
        //We set the token info and the token access
        localStorage.setItem('x-access-machine-token', token);
        localStorage.setItem('business', JSON.stringify(business));
        localStorage.setItem('branchoffice', JSON.stringify(branchoffice));
        localStorage.setItem('branchoffice_original', JSON.stringify(branchoffice));
        localStorage.setItem('machine', JSON.stringify(machine_info));
        localStorage.setItem('machine_original', JSON.stringify(machine_info));
        if (moduloEvents == true) {
            localStorage.setItem('event', JSON.stringify(selectedEvent));
        }

        if (url_path.pathname.includes('customer')) {
            navigate(`/orders/business/${business_code}/branchoffice/${selectedBranch}/list`)
        } else if (url_path.pathname.includes('comanda')) {
            localStorage.setItem('x-access-token', token);
            //We get the machine categories available
            try {
                const catResponse = await MachinesFetchAPI.getMachineCategories(machine_info.id, token)
                localStorage.setItem('machine', JSON.stringify({ categories_available: catResponse.data.categories, ...machine_info }))
            } catch (err) {
                localStorage.setItem('machine', JSON.stringify({ categories_available: [], ...machine_info }))
            }

            navigate(`/kds/${business_code}/${selectedBranch}`)
        } else if (url_path.pathname.includes('tables') && url_path.pathname.includes('machines')) {
            navigate(`/tables/login/${business_code}/${selectedBranch}`)
            //We get the branchoffice tables
            getBranchofficeTables(branchoffice.id, token)
        } else {
            //We get the branchoffice data
            getUsers(branchoffice.id, selectedBranch);
            setEventListener(1);
            //We redirect
            navigate(`/machine/cashier/login/${business_code}/${selectedBranch}`)
        }
    }

    //Event to login a machine
    const loginMachine = async (e) => {

        e.preventDefault();
        if (statusAuth === false) {
            setStatusAuth(true)

            if (selectedBranch !== null) {
                const form = new FormData(e.target);
                form.append('branchoffice_code', selectedBranch);
                form.append('business_code', business_code);
                let machine = Object.fromEntries(form.entries());
                try {
                    await attemptLoginMachine(machine);
                } catch (err) {
                    // Caja de comandas / auto-aprobacion en uso: el servidor no deja tomarla, ni confirmando.
                    if (err.response?.status === 409 && err.response?.data?.code === 'MACHINE_PROTECTED') {
                        setStatusAuth(false);
                        Swal.fire({
                            icon: 'error',
                            title: 'Caja en uso',
                            text: err.response.data.error,
                            confirmButtonText: 'Entendido',
                        });
                        return;
                    }

                    // Single-session-per-terminal: this machine is already claimed elsewhere - offer
                    // to take it over instead of just failing outright.
                    if (err.response?.status === 409 && err.response?.data?.code === 'MACHINE_ALREADY_LOGGED_IN') {
                        setStatusAuth(false);
                        const otherMachine = err.response.data.data || {};
                        // Backend only returns machine_code here, not machine_name - look up the
                        // name from the branchoffice machines already loaded for this screen.
                        const matchedMachine = branchofficeMachines.find(m => m.code === otherMachine.machine_code);
                        const otherMachineName = otherMachine.name || otherMachine.machine_name || matchedMachine?.machine_name || otherMachine.machine_code || 'Esta terminal';
                        const cashierText = otherMachine.cashier_name ? ` (cajero: ${otherMachine.cashier_name})` : '';
                        const result = await Swal.fire({
                            icon: 'warning',
                            title: 'Terminal ocupada',
                            text: `"${otherMachineName}" ya tiene una sesion activa${cashierText}. Si continuas, esa sesion se cerrara.`,
                            showCancelButton: true,
                            confirmButtonText: 'Cerrar y continuar aqui',
                            cancelButtonText: 'Cancelar',
                            reverseButtons: true,
                        });

                        if (result.isConfirmed) {
                            setStatusAuth(true);
                            try {
                                await attemptLoginMachine({ ...machine, force_transfer: true });
                            } catch (retryErr) {
                                setStatusAuth(false);
                                Swal.fire({
                                    icon: "error",
                                    title: retryErr.response?.data?.error || 'No fue posible iniciar sesion',
                                    showConfirmButton: false,
                                    timer: 1500,
                                });
                            }
                        }
                        return;
                    }

                    setStatusAuth(false)
                    Swal.fire({
                        icon: "error",
                        title: err.response?.data?.error || 'No fue posible iniciar sesion',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }

            } else {
                //If the user dont select any branch we throw an error
                Swal.fire({
                    icon: "error",
                    title: 'Seleccione una sucursal',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }

        }

    }




    //Hook to get data when the page is loaded
    useEffect(() => {
        //We get the business by code 
        getInitialData(business_code);
        if (branchoffice_code === undefined) {
            getUsers(0, 0);
        }

    }, [eventListener]);

    //Function to gen the list of the branchoffices 
    const branchofficesList = () => {
        const branchoffices_list = branchInView.map((data) => (
            <>
                <option data-code={data.branchoffice_code} value={data.branchofficeId}>{data.branchofficeName}</option>
            </>
        ))

        //We check the branchoffices 
        if (branchoffices.length === 0) {
            return (
                <>
                    <option value={null}>No hay sucursales registradas</option>
                </>
            )
        } else {
            return (
                <>
                    <option value={null}>Seleccione...</option>
                    {branchoffices_list}
                </>
            )
        }
    }

    // Listado visual de eventos para paso a paso
    const eventsList = () => {
        if (events.length === 0) {
            return (
                <div className="spl-empty">No hay eventos activos o próximos disponibles.</div>
            );
        }
        // Ordenar eventos por la fecha inicial más temprana
        const sortedEvents = [...events].sort((a, b) => {
            const aDate = a.dates && a.dates.length > 0 ? new Date(a.dates[0].initialDate) : new Date(8640000000000000);
            const bDate = b.dates && b.dates.length > 0 ? new Date(b.dates[0].initialDate) : new Date(8640000000000000);
            return aDate - bDate;
        });
        return (
            <div className="spl-list">
                {sortedEvents.map((event) => (
                    <button
                        key={event.id}
                        type="button"
                        className="spl-row"
                        onClick={() => {
                            setSelectedEvent(event);
                            setStepEvent(false);
                            getBranchByEvent(JSON.stringify(event));
                        }}
                    >
                        <span className="spl-rtext">
                            <span className="spl-r1">{event.name}</span>
                        </span>
                        <span className={`spl-status ${event.tipoEvento === 'En curso' ? 'spl-live' : ''}`}>
                            <span className={`spl-dot ${event.tipoEvento === 'En curso' ? 'spl-live' : 'spl-soon'}`}></span>
                            {event.tipoEvento}
                        </span>
                        <span className="spl-go">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 6-6 6" /></svg>
                        </span>
                    </button>
                ))}
            </div>
        );
    };

    //Function to list the users of branchoffice
    const listUsers = () => {
        let users_list;
        if (users !== undefined) {
            users_list = users.map((data) => (
                <React.Fragment key={data.user_id}>
                    <input type="radio" className="spl-choice" name="email" id={data.user_id} value={data.email} />
                    <label className="spl-row" htmlFor={data.user_id}>
                        <span className="spl-avatar">{splInitials(data.user_name)}</span>
                        <span className="spl-rtext"><span className="spl-r1">{data.user_name}</span></span>
                        <span className="spl-radio">
                            <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2 5 8.6l4.5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </span>
                    </label>
                </React.Fragment>
            ))
        } else {
            users_list = ''
        }

        //We check the users list
        return (<>{users_list} </>)
    }

    //Function to list the machines of a branchoffice 
    const listMachines = () => {


        const machines_list =
            branchofficeMachines.length === 0
                ? <div className='flex-column justify-content-center  mt-4 opacity-25 bg-primrary '>
                    <div className='d-flex justify-content-center'>
                        <animated-icons
                            src="https://animatedicons.co/get-icon?name=Retail&style=minimalistic&token=7b7f631c-8731-466a-b7df-99e77887f0f0"
                            trigger="click"
                            attributes='{"variationThumbColour":"#FFFFFF","variationName":"Normal","variationNumber":1,"numberOfGroups":1,"backgroundIsGroup":false,"strokeWidth":1,"defaultColours":{"group-1":"#000000","background":"#FFFFFF"}}'
                            height="60"
                            width="60"
                        ></animated-icons>
                    </div>
                    <small className='text-black text-center d-flex justify-content-center'>
                        Seleccione la sucursal de la empresa <br /> para mostrar las máquinas disponibles.
                    </small>
                </div>
                : branchofficeMachines.map((data) => (
                    <>

                        <React.Fragment key={data.machine_per_branch_id}>
                            {/* "Ocupada" is informational only - selecting a busy terminal is allowed on
        purpose (see LoginCashier.jsx#submit). The real single-session guarantee
        happens at the cashier/user login step, which can detect and move that
        specific user's session between terminals; blocking here would prevent that
        legitimate "move my session" flow from ever starting. */}
                            <input
                                type="radio"
                                className="spl-choice"
                                name="machine_code"
                                id={data.machine_per_branch_id}
                                value={data.code}
                            />
                            <label className="spl-row" htmlFor={data.machine_per_branch_id}>
                                <span className="spl-mico">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="13" rx="2" /><path d="M8 21h8M12 17v4" /></svg>
                                </span>
                                <span className="spl-rtext">
                                    <span className="spl-r1">
                                        {data.machine_name}
                                        {data.is_logged === 1 && (<span className="spl-badge spl-busy">Ocupada</span>)}
                                    </span>
                                </span>
                                <span className="spl-radio">
                                    <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2 5 8.6l4.5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                </span>
                            </label>
                        </React.Fragment>
                    </>


                ));
        return (<>{machines_list} </>)
    }

    //Function to get branch tables
    const listBranchTables = () => {
        const tables_list = branchofficeTables.map((data) => (
            <React.Fragment key={data.id}>
                <input type="radio" className="spl-choice" name="table_id" id={data.id} value={data.id} />
                <label className="spl-row" htmlFor={data.id}>
                    <span className="spl-rtext"><span className="spl-r1">{data.name}</span></span>
                    <span className="spl-radio">
                        <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2 5 8.6l4.5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    </span>
                </label>
            </React.Fragment>
        ))
        //We check the users list
        return (<>{tables_list} </>)
    }

    //Function to list the tables of a branchoffice 
    const getBranchofficeTables = async (branchoffice_id, token) => {
        try {
            //Variables 
            let response = await TablesFetchAPI.getBranchofficeTables(branchoffice_id, token)
            setBranchofficeTables(response.data.tables)
        } catch (err) {
            //If we get some error we set the users data empty 
            setBranchofficeTables([])
            setSelectedBranch(null)
        }
    }

    //Function to login the table 
    const loginTable = async (e) => {
        e.preventDefault();
        if (selectedBranch !== null) {
            const form = new FormData(e.target);
            let table = Object.fromEntries(form.entries());
            try {
                const response = await AuthFetchAPI.loginBranchTable(table);
                //We get the token and user data 
                localStorage.setItem('table', JSON.stringify(response.data.table));
                navigate(`/preaccount/${business_code}/${branchoffice_code}`)
            } catch (err) {
                Swal.fire({
                    icon: "error",
                    title: err.response.data.error,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }

        } else {
            //If the user dont select any branch we throw an error
            Swal.fire({
                icon: "error",
                title: 'Seleccione una sucursal',
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }

    const [showPassword, setShowPassword] = useState('')
    const toogglePasword = () => {

        setShowPassword(!showPassword);

    }

    function areMachineLocalStorageValuesLoaded() {
        const requiredKeys = [
            "x-access-machine-token",
            "business",
            "branchoffice",
            "branchoffice_original",
            "machine",
            "machine_original"
        ];
        for (const key of requiredKeys) {
            const value = localStorage.getItem(key);
            if (
                value === null ||
                value === undefined ||
                value === "" ||
                value === "undefined" ||
                value === "null"
            ) {
                return false;
            }
        }
        return true;
    }


    useEffect(() => {

        let urlNow = window.location.href + ""
        let arrayParams = urlNow.split('/');
        console.log(arrayParams[3] + " " + arrayParams[4]);
        authValidSesion()

        if (arrayParams[3] === "machines" && arrayParams[4] === "login") {
            console.log("entre");

            if (localStorage.getItem("x-access-token") === "" || localStorage.getItem("x-access-token") == undefined || localStorage.getItem("x-access-machine-token") === "" || localStorage.getItem("x-access-machine-token") === undefined || localStorage.getItem("branchoffice") === "" || localStorage.getItem("branchoffice") === undefined || localStorage.getItem("machine") === "" || localStorage.getItem("machine") === undefined || localStorage.getItem("user") === "" || localStorage.getItem("user") === undefined) {

            } else {

                let branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
                let machine = JSON.parse(localStorage.getItem('machine'));
                let business = JSON.parse(localStorage.getItem("business"))
                //console.log(`/kiosk/${business.code}/${branchoffice.code}`);

                if (areMachineLocalStorageValuesLoaded() == true) {

                    console.log("Se valido loa valores de local storage");
                    //navigate(`/payments/${business.code}/${branchoffice.code}`)
                }

            }
        }
    }, []);


    const selectBranch = () => {
        return (
            <>
                <h1 className="spl-title">Elige la sucursal y la caja</h1>
                <p className="spl-sub">Indica desde qué punto de venta vas a operar.</p>
                <div className="spl-field">
                    <label className="spl-lbl" htmlFor="branchoffice">Sucursal de la empresa</label>
                    <div className="spl-select-wrap">
                        <select className="spl-select" onChange={e => {
                            //We get the code selected on the select 
                            let index = e.target.selectedIndex;
                            let optionElement = e.target.childNodes[index]
                            let code = optionElement.getAttribute('data-code');
                            //We get the users of the branch
                            getUsers(e.target.value, code);
                            getMachinesBranchoffice(e.target.value, code);
                        }}
                            name="branchoffice" id="branchoffice">
                            {branchofficesList()}
                        </select>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6" /></svg>
                    </div>
                </div>
            </>
        )
    }


    return (
        <div className="spl-page">

            {/* Degradado superior (verde -> azul) */}
            <div className="spl-topglow" aria-hidden="true"></div>

            {/* Nav superior */}
            <nav className="spl-nav">
                <span className="spl-brand">
                    SmartPay <span className="spl-pos">POS</span>
                </span>
                <span className="spl-company">{businessData.name}</span>
            </nav>

            <main className="spl-content">
                <div className="spl-wrap">

                    <div className="spl-eyebrow">Inicio de Sesión</div>

                    {/**Branchoffice select */}
                    <RenderIf isTrue={(url_path.pathname.includes('cashier') && branchoffice_code === undefined) || url_path.pathname.includes('dispatcher') || url_path.pathname.includes('machines') || url_path.pathname.includes('comanda')} >
                        {moduloEvents === true ? (
                            stepEvent ? (
                                <>
                                    <h1 className="spl-title">¿Bajo qué evento vas a trabajar?</h1>
                                    <p className="spl-sub">Selecciona un evento activo o continúa sin uno.</p>
                                    {eventsList()}
                                    <button
                                        className="spl-center-link"
                                        type="button"
                                        onClick={() => { setModuloEvents(false); setBtnReturnEvents(true); setBranchInView(branchoffices); setStepEvent(true); setSelectedEvent(null) }}
                                    >
                                        Continuar sin evento →
                                    </button>
                                </>
                            ) : (
                                <>
                                    <div className="spl-eventbar">
                                        <span className="nm">
                                            Evento: {selectedEvent?.name}
                                            <span className="spl-badge spl-soon">{selectedEvent?.tipoEvento}</span>
                                        </span>
                                        <button
                                            className="spl-back"
                                            type="button"
                                            onClick={() => { setStepEvent(true); setSelectedEvent(null); setBranchInView([]); setBranchofficeMachines([]); setSelectedBranch(null); }}
                                        >
                                            ← Volver
                                        </button>
                                    </div>
                                    {selectBranch()}
                                </>
                            )
                        ) : (
                            <>
                                {btnReturnEvents === true && (
                                    <div className="spl-actions spl-end">
                                        <button
                                            className="spl-back"
                                            type="button"
                                            onClick={() => { setStepEvent(true); setSelectedEvent(null); setBranchInView([]); setModuloEvents(true); setBtnReturnEvents(false); setBranchofficeMachines([]); setSelectedBranch(null); }}
                                        >
                                            ← Volver
                                        </button>
                                    </div>
                                )}
                                {selectBranch()}
                            </>
                        )}
                    </RenderIf>

                    {/**List and form of users depending the branchoffice */}
                    <RenderIf isTrue={url_path.pathname.includes('cashier') || url_path.pathname.includes('dispatcher') || !url_path.pathname.includes('machines') && !url_path.pathname.includes('comanda') && !url_path.pathname.includes('tables')}>
                        {/*Form */}
                        <form onSubmit={submit} className="spl-form" noValidate>
                            <h1 className="spl-title">¿Quién va a iniciar sesión?</h1>
                            <p className="spl-sub">Selecciona tu usuario para continuar.</p>
                            <div className="spl-list">
                                {listUsers()}
                            </div>

                            <div className="spl-field" style={{ marginTop: '20px', marginBottom: 0 }}>
                                <label className="spl-lbl" htmlFor="password">Contraseña</label>
                                <div className="spl-pwd-wrap">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className="spl-input"
                                        id="password"
                                        name='pass'
                                        placeholder="Ingresar contraseña"
                                        required
                                        spellCheck="false"
                                    />
                                </div>
                            </div>

                            <label className="spl-checkrow">
                                <input className="" type="checkbox"
                                    value="remember-me" id="flexCheckDefault"
                                    onChange={toogglePasword}
                                />
                                <span className="spl-cbox">
                                    <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2 5 8.6l4.5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                </span>
                                <span>Mostrar contraseña</span>
                            </label>

                            <div className="spl-actions">
                                <button className="spl-back" type="button" onClick={() => signout()}>← Volver</button>
                                <button className="spl-btn spl-btn-primary" type="submit">Ingresar</button>
                            </div>
                        </form>
                    </RenderIf>

                    {/**List and form of machines depending the branchoffice */}
                    <RenderIf isTrue={
                        (url_path.pathname.includes('machines') || url_path.pathname.includes('comanda')) &&
                        (
                            (moduloEvents === true && selectedEvent !== null && !stepEvent) ||
                            moduloEvents === false
                        )
                    }>
                        {/*Form */}
                        <form onSubmit={loginMachine} className="spl-form" noValidate>
                            <label className="spl-lbl">Máquinas</label>
                            <div className="spl-list">
                                {listMachines()}
                            </div>
                            <button className="spl-btn spl-btn-primary spl-btn-block" type="submit" style={{ marginTop: '16px' }}>
                                Ingresar
                            </button>
                        </form>
                    </RenderIf>

                    {/**LIst and form of tables depending the branchoffice */}
                    <RenderIf isTrue={url_path.pathname.includes('tables') && !url_path.pathname.includes('machines')}>
                        {/*Form */}
                        <form onSubmit={loginTable} className="spl-form" noValidate>
                            <label className="spl-lbl">Mesas</label>
                            <div className="spl-list">
                                {listBranchTables()}
                            </div>
                            <button className="spl-btn spl-btn-primary spl-btn-block" type="submit" style={{ marginTop: '16px' }}>
                                Ingresar
                            </button>
                        </form>
                    </RenderIf>

                </div>
            </main>

            {/* Footer */}
            <footer className="spl-footer">
                <div className="spl-footer-in">
                    <span className="spl-fbrand">
                        SmartPay <span className="spl-pos">POS</span>
                    </span>
                    {/* <nav className="spl-flinks">
                        <a href="#">Privacidad</a>
                        <a href="#">Términos</a>
                        <a href="#">Soporte</a>
                    </nav> */}
                    <span className="spl-fcopy">© 2026 ·</span>
                </div>
            </footer>

        </div>
    )
}

export default Login